import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../__root";
import { z } from "zod";

export const registerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/register",
  validateSearch: z.object({
    token: z.string().optional(),
  }),
}).lazy(() => import("./Register.lazy").then((d) => d.Route));
